import { lazy } from "react";
import { createBrowserRouter, RouterProvider, type RouteObject } from "react-router";
import { Layout, RequireAuth } from "./components/Layout";
import { LeaderboardPage } from "./pages/Leaderboard";
import { LoginPage, ResetPage, SignupPage } from "./pages/Auth";
import { MarketsPage } from "./pages/Markets";

// The market page carries the charting library and the admin console is for
// one person, so both load on demand instead of in the first download.
const MarketPage = lazy(() => import("./pages/Market").then((m) => ({ default: m.MarketPage })));
const AdminPage = lazy(() => import("./pages/Admin").then((m) => ({ default: m.AdminPage })));
import { NewMarketPage } from "./pages/NewMarket";
import { NotFoundPage } from "./pages/NotFound";
import { NotificationsPage } from "./pages/Notifications";
import { ProfilePage } from "./pages/Profile";
import { SettingsPage } from "./pages/Settings";

export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/signup", element: <SignupPage /> },
      { path: "/reset", element: <ResetPage /> },
      {
        element: <RequireAuth />,
        children: [
          { path: "/", element: <MarketsPage /> },
          { path: "/m/:id", element: <MarketPage /> },
          { path: "/new", element: <NewMarketPage /> },
          { path: "/u/:username", element: <ProfilePage /> },
          { path: "/leaderboard", element: <LeaderboardPage /> },
          { path: "/notifications", element: <NotificationsPage /> },
          { path: "/settings", element: <SettingsPage /> },
        ],
      },
      { element: <RequireAuth admin />, children: [{ path: "/admin", element: <AdminPage /> }] },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];

const router = createBrowserRouter(routes);

export function App() {
  return <RouterProvider router={router} />;
}
